export const SAMPLES = [
  { key: "logo", label: "B&W logo", file: "/samples/logo.png", params: { style: "extrude", add_base: true } },
  { key: "silhouette", label: "Silhouette", file: "/samples/silhouette.jpg", params: { style: "extrude", add_base: false } },
  { key: "photo", label: "Photograph", file: "/samples/photo.jpg", params: { style: "heightmap", smoothing: 1.5, depth_mm: 4 } },
  { key: "illustration", label: "Illustration", file: "/samples/illustration.jpg", params: { style: "heightmap", depth_mm: 3 } },
];

export const DEFAULT_PARAMS = {
  style: "extrude",
  width_mm: 100,
  height_mm: null,
  depth_mm: 3,
  add_base: true,
  base_mm: 2,
  resolution: 200,
  smoothing: 1,
  invert: false,
  threshold: null,
  use_alpha: true,
  background_color: "#ffffff",
  rotation_z: 0,
  stand_upright: false,
  scale: 1,
  mounting_hole: false,
  hole_diameter_mm: 4,
};

export const ACCEPT = ["image/png", "image/jpeg", "image/webp"];

export const fileFromSample = async (sample) => {
  const res = await fetch(sample.file);
  const blob = await res.blob();
  return new File([blob], sample.file.split("/").pop(), { type: blob.type });
};
